/**
 * Navigation icon names.
 * Mirror of `Components/icons/navigation/enIcons`
 */
export var NavigationIcons;
(function (NavigationIcons) {
    NavigationIcons["Accounts"] = "EnIconAccounts";
    NavigationIcons["Customer"] = "EnIconCustomer";
    NavigationIcons["Dashboard"] = "EnIconDashboard";
    NavigationIcons["Development"] = "EnIconDevelopment";
    NavigationIcons["EnCount"] = "EnIconEnCount";
    NavigationIcons["EnFlow"] = "EnIconEnFlow";
    NavigationIcons["EnTab"] = "EnIconEnTab";
    NavigationIcons["Logout"] = "EnIconLogout";
    NavigationIcons["Other"] = "EnIconOther";
    NavigationIcons["RentalData"] = "EnIconRentalData";
    NavigationIcons["Tools"] = "EnIconTools";
    NavigationIcons["User"] = "EnIconUser";
})(NavigationIcons || (NavigationIcons = {}));
